//
//
//
//

import {formatDimension} from "../../helpers/format_helpers";

export default {
    name: "Divider",

    props: {
        // The text to display within the dividing line
        text: {
            type: String,
            default: null
        },

        // The vertical spacing (or horizontal for vertical dividers)
        margin: {
            type: [Number, String],
            default: 32
        },

        // Whether the divider shall be rendered vertically
        vertical: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        style() {
            if (this.vertical) {
                return {
                    'margin-left': formatDimension(this.margin),
                    'margin-right': formatDimension(this.margin)
                }
            }
            return {
                'margin-top': formatDimension(this.margin),
                'margin-bottom': formatDimension(this.margin)
            }
        }
    }
}
